(function () {
  document.querySelectorAll('[data-puddleford-build-kit]').forEach(function (root) {
    var button = root.querySelector('[data-kit-add]');
    if (!button) return;

    var colourButtons = Array.prototype.slice.call(root.querySelectorAll('[data-kit-colour]'));
    var sizeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-kit-size]'));
    var priceEl = root.querySelector('[data-kit-robe-price]');
    var nameEl = root.querySelector('[data-kit-robe-name]');
    var imageEl = root.querySelector('[data-kit-robe-image]');
    var dataEl = root.querySelector('[data-kit-robe-variants]');

    var variants = [];
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var robeBaseName = nameEl ? nameEl.textContent.trim() : '';
    var labelReady = button.getAttribute('data-label-ready');
    var labelIncomplete = button.getAttribute('data-label-incomplete');

    var selectedColour = null;
    var selectedSize = null;
    var selectedVariant = null;

    // No selectors rendered (a single-variant robe): nothing to gate on.
    var needsChoice = colourButtons.length > 0 || sizeButtons.length > 0;
    if (!needsChoice) {
      button.disabled = false;
      button.textContent = labelReady;
    }

    function press(buttons, active) {
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', b === active ? 'true' : 'false');
      });
    }

    function findVariant() {
      if (colourButtons.length && !selectedColour) return null;
      if (sizeButtons.length && !selectedSize) return null;

      return (
        variants.filter(function (v) {
          if (colourButtons.length && v.colour !== selectedColour) return false;
          if (sizeButtons.length && v.size !== selectedSize) return false;
          return true;
        })[0] || null
      );
    }

    function refresh() {
      selectedVariant = findVariant();

      if (selectedVariant) {
        button.disabled = false;
        button.textContent = labelReady;
        if (nameEl) nameEl.textContent = robeBaseName + ' (' + selectedVariant.title + ')';
        if (priceEl) priceEl.textContent = selectedVariant.price;
      } else {
        button.disabled = true;
        button.textContent = labelIncomplete;
      }
    }

    colourButtons.forEach(function (colourButton) {
      colourButton.addEventListener('click', function () {
        selectedColour = colourButton.getAttribute('data-kit-colour');
        press(colourButtons, colourButton);

        // Swap the robe thumbnail to this colour's own photograph.
        var match = variants.filter(function (v) {
          return v.colour === selectedColour && v.image;
        })[0];
        if (match && imageEl) imageEl.src = match.image;

        refresh();
      });
    });

    sizeButtons.forEach(function (sizeButton) {
      sizeButton.addEventListener('click', function () {
        selectedSize = sizeButton.getAttribute('data-kit-size');
        press(sizeButtons, sizeButton);

        // Price follows size even before a colour is picked.
        if (priceEl && !selectedVariant) {
          priceEl.textContent = sizeButton.getAttribute('data-price');
        }

        refresh();
      });
    });

    button.addEventListener('click', function () {
      if (needsChoice && !selectedVariant) return;

      var items = [];
      if (selectedVariant) items.push({ id: selectedVariant.id, quantity: 1 });

      root.querySelectorAll('[data-kit-item]:checked').forEach(function (checkbox) {
        items.push({ id: parseInt(checkbox.getAttribute('data-variant-id'), 10), quantity: 1 });
      });

      if (!items.length) return;

      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = originalText;
        });
    });
  });
})();
